import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/system';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow'; 

import TableCell from '@mui/material/TableCell';
import Radio, { RadioProps } from '@mui/material/Radio';
import Autocomplete from '@mui/material/Autocomplete';
import FormLabel from '@mui/material/FormLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloseIcon from '@mui/icons-material/Close';
import template1 from './images/template1.png';
import template2 from './images/template2.png';
import AttachmentIcon from '@mui/icons-material/Attachment';
import TableHead from '@mui/material/TableHead';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

let strCust=[{title:'',year:'0'}];

const useStyles = styled(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default class TemplateLogo extends Component {
constructor(props) {
    super(props);

	this.state = {
  templateData: [],redirect:false,pagename:'',
  submitbtn: 'Save',
  selectedTheme: null,
  themecolor: [
    { color: "#e2e3e5" },
    { color: "#ffb7b7" },
    {  color: "#e2c9f2" },
    { color: "#fde5b2" },
    {  color: "#f6c5b3" },
    {  color: "#bcf0db" },
    {  color: "#008000" },
    {  color: "#c6c4f8" },
    {  color: "#b9d9fd" },
    {  color: "#f7cad5" },
   
  ],
  selectedborder:null,se_file:'',
};

      }
   

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


componentWillMount() {
	document.title = "Isifol Account - Business Setting";



 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 
			 
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		   let strname="Templates and logos ";
		   
	 this.props.parentdasCallback(
            strname+"~"
        ); 
		
	 this.GetBusinessSetting();

} 

PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=19')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
 
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
   handleSubmit= (event) => {
	 
	 event.preventDefault();    

	
	let optionsVal=this.state.templateData;
	
		let optionValues="";
    let sep2="";
	
	 
	  optionsVal.forEach(eachval => {
		  
			 optionValues=optionValues+sep2+eachval.bs_id+"~"+eachval.bs_value;
		 sep2="`"
	 
		   
	   });
	   
	   this.setState({btndisabled:true,submitbtn:"Processing"})
    const formData = new FormData();
     formData.append('action','update')
	 formData.append('business',optionValues)
	 formData.append('bs_page',5)
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('groupmaster','')
     formData.append('userid',0)
     formData.append('deletegm_id','')
    
	 
	 	 axios.post(localStorage.getItem("ISIurl")+"ajaxbusinesssetting.php", formData, {
        }).then(res => {
			
			 this.setState({
      errormessage: "Updation Sucessfull",
      erropen: true,errortype:'success',btndisabled:false,submitbtn:"Save"
    });
    window.scrollTo({ top: 0 });
    return false;
			
	

			
		
   }); 
	
  };



GetBusinessSetting() {
  let strsettings = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=5&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data) {
        this.setState({
          templateData:resp.data,
		
        },()=>{
			
		
		});
      } else {
        this.setState({templateData: [] });
      }
    })
   
}

HandleRadioChange = (id, rowsd) => (event) => {
  const value = event.target.value; 
  const updatedArray = [...this.state.templateData]; 

  updatedArray[rowsd].bs_value = value; 


 
  this.setState({ templateData: updatedArray }, () => {
    console.log('Updated BusiCustomerData:', this.state.templateData);
  });
};



RemoveLogoHanler = (rows) => (event) => {
	
const updatedArray = [...this.state.templateData];  
		  updatedArray[rows].bs_value = "";
		  this.setState({templateData:updatedArray});
		  
}

onAddFileChange = (rows)=>(e) => {
	
  const imageFile = e.target.files[0];
 const sizeInKB = imageFile.size / 1024;
 

 
  if (!imageFile) {
    this.setState({ 
      errormessage: "No file selected. Please choose a file to upload.", 
      erropen: true 
    });
    window.scrollTo({ top: 0 });
    return;
  }
else if (!imageFile.name.match(/\.(png|jpeg|jpg)$/)) {
    this.setState({
      errormessage: "Please upload a file with one of the following formats: .png, .jpeg, .jpg",
      erropen: true,errortype:'error',
    });
    window.scrollTo({ top: 0 });
    return false;
  }

    this.setState({
    preview: URL.createObjectURL(imageFile),
    se_file: e.target.files
  }, () => {
       const formData = new FormData();
    formData.append('action', 'getfilename');

    for (const key of Object.keys(this.state.se_file)) {
      formData.append('Filedata', this.state.se_file[key]);
    }

     axios.post(localStorage.getItem("ISIurl") + "ajaxbusinesssetting.php", formData)
      .then(res => {
   let strreturn=res.data.trim();
		const updatedArray = [...this.state.templateData];  
		  updatedArray[rows].bs_value = strreturn;
		  
		  
		
	 this.setState({ templateData: updatedArray,se_file:""}); 
      })
     
  });
};
	

selectedThemeHandler = (color, index) => {
  this.setState({ selectedTheme: color}, () => {
    const updatedArray = [...this.state.templateData];
    updatedArray[index].bs_value = color;
    this.setState({ templateData: updatedArray });
  });
};



InputThemeHandler = (firstrow) => (event) => { 
  let nam = event.target.name;
  let val = event.target.value;
  
  const updatedArray = [...this.state.templateData];  

  if (nam === "inputthemecolor") {
	  this.setState({selectedTheme:val})
    updatedArray[firstrow].bs_value = val;
	 this.setState({ templateData: updatedArray,}); 
  }
 
};


  render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  
  return (
 
		<React.Fragment>
	
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
	
	
	<div className="emaildoc">
  <div className="businesssetting">
   
      <Table>
        {this.state.templateData.map((item, index) => (
          <React.Fragment key={index}>
            {item.bs_id === "1" && (
              <TableRow>
			  
                <TableCell
                  sx={{
                    verticalAlign: "top",
                    width: { xs: "200px", md: "400px" },
                  }}
                >
				 
                  <h6>{item.bs_title}</h6>
                  <p>Select the layout for your documents.</p>
                  <p>Change what’s shown on invoices and other sales and purchase documents and edit column headings in <a href="#">Document preferences.</a></p>
              

     			  </TableCell>

                <TableCell>
				
                  <div className="templatediv">
				  
				  <ul>
				  <li>
				<h4>Product based</h4>
				Shows product codes, quantities and unit prices.
                   <img src={template1} alt="Template" />
				   <p>
					 <FormControl className="preference">
                  <RadioGroup
				  onChange={this.HandleRadioChange(item.bs_id, index)}
                      value={item.bs_value}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
                     <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Emerald (Product)"
                      />
					  </RadioGroup>
                  </FormControl> </p>
				  
				  </li>
				  
				  
				  <li>
				  
				  
				<img src={template2} alt="Template" />
				<p><FormControl className="preference">
                  <RadioGroup
				    onChange={this.HandleRadioChange(item.bs_id, index)}
                      value={item.bs_value}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
                    <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Pepper (Product)"
                      />
					  </RadioGroup>
                  </FormControl></p></li>
				  
				  </ul>
				  
				  
				  
				  
                  </div>
				  
				  
				  
                </TableCell>
				
               
              </TableRow>
            )}
			
			
			
			
			
			
			 {item.bs_id === "2" && (
              <TableRow>
			  
                <TableCell
                  sx={{
                    verticalAlign: "top",
                    width: { xs: "200px", md: "400px" },
                  }}
                >
				 
                  <h6>{item.bs_title}</h6>
                  <p>Add secondary logos i.e. for accreditations or trade memberships. JPG, PNG or GIF formats.</p>
                  <p>Recommended size 180 x 200 pixels.</p>
              

     			  </TableCell>

                <TableCell>
<div 
  className="uploadlogobtndiv" 
  style={{ 
    backgroundImage: 'url(' + localStorage.getItem("ISIurl") + 'uploads/' + item.bs_value + ')'
  }}
>
 <span className="uploadcloseicon" onClick={this.RemoveLogoHanler(index)}><CloseIcon /></span>
  <p>
    <Button
      component="label"
      className="uploadlogobtn"
      name="se_file"
      onChange={this.onAddFileChange(index)}
      variant="contained"
      accept="image/*;capture=camera"
      startIcon={<CloudUploadIcon />}
	  
    >
      <VisuallyHiddenInput type="file" />
    </Button>
	
  </p>
  
   
</div>


			
</TableCell>


				
				<TableCell>
				
				
				</TableCell>
               
              </TableRow>
            )}
			
					
			
			 {item.bs_id === "3" && (
              <TableRow>
			  
                <TableCell
                  sx={{
                    verticalAlign: "top",
                    width: { xs: "200px", md: "400px" },
                  }}
                >
				 
                  <h6>{item.bs_title}</h6>
                  <p>ASelect an accent color for your documents</p>
         
              

     			  </TableCell>

 <TableCell>
   <div className="themecolor">
  <ul>
    {this.state.themecolor.map((theme, indx) => (
      <li
        key={indx}
        onClick={() => this.selectedThemeHandler(theme.color, index)} 
        style={{
          border: '2px solid ' + (
          
            item.bs_value=== theme.color
              ? 'black' 
              : theme.color
          ),
          backgroundColor: theme.color,
        }}
      ></li>
    ))}
  </ul>
</div>

<div className="inputcolordiv">
<span className="orvalcenter">or </span>
<p>Colour Hex Code (advanced)</p>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			
          
            name="inputthemecolor"
			onChange={this.InputThemeHandler(index)}
            
			
		 />
		</div> 
		 
		 <div className="clear"></div>

<div className="selectthemebg">
  <p>Preview</p>
  <Table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr>
        <th style={{ border: "1px solid black", backgroundColor: item.bs_value || "transparent", textAlign: "left", padding: "8px" }}>
          Product Code
        </th>
        <th style={{ border: "1px solid black", backgroundColor: item.bs_value || "transparent", textAlign: "left", padding: "8px" }}>
          Description
        </th>
        <th style={{ border: "1px solid black", backgroundColor: item.bs_value || "transparent", textAlign: "left", padding: "8px" }}>
          Quantity
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>PROD001</td>
        <td>Item</td>
        <td>1</td>
      </tr>
      <tr>
        <td>PROD002</td>
        <td>Another Item</td>
        <td>2</td>
      </tr>
    </tbody>
  </Table>
</div>
</TableCell>



				 
              </TableRow>
            )}
			
		
			
          </React.Fragment>
        ))}
      </Table>
    
    <div className="clear"></div>
  </div>
  
  
  <div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Fonts</h5>
      <p>
       Select a font for your documents.
      </p>
    </div>
   
   <div className="pagecontentright">
      <Table>
        {this.state.templateData.map((item, index) => (
          <React.Fragment key={index}>
            
			{item.bs_id === "4" && (
            <TableRow>
             <h6>{item.bs_title} </h6>
              <TableCell>
			
               	<Select
				  native
				  variant="outlined" className="txtbox"
				  margin="normal"
				  id="bs_value"
				  value={item.bs_value}
				  name="bs_value"
				  inputProps={{tabIndex: "4"}}
				  style={{width:" 20%"}}
				  onChange={this.HandleRadioChange(item.bs_id, index)}
				>
				<option value={0}></option>
				<option value={"Arial"}>Arial</option>
				<option value={"Helvetitaka"}>Helvetitaka</option>	
				
				</Select>
              
              </TableCell>
            </TableRow>
          )}

			
			
		{item.bs_id === "5" && (
            <TableRow>
           <h6>{item.bs_title} </h6>
              <TableCell>
			  
			   
               	<Select
				  native
				  variant="outlined" className="txtbox"
				  margin="normal"
				  id="bs_value"
				  value={item.bs_value}
				  name="bs_value"
				  inputProps={{tabIndex: "5"}}
		        style={{width:" 20%"}}
				  onChange={this.HandleRadioChange(item.bs_id, index)}
				>
				<option value={0}></option>
				<option value={18}>Small</option>
				<option value={20}>Medium</option>	
				<option value={22}>Large</option>	
				
				</Select>
              
              </TableCell>
            </TableRow>
          )}
			
          </React.Fragment>
        ))}
      </Table>
	  </div>
    
    <div className="clear"></div>
  </div>
  
  
  
  
  
  
  
  
</div>

	  
	  
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
     




<p className="aligncentr"> 
	 <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   {this.state.submitbtn}
</Button></p>
		 

 </React.Fragment>
  );
  }
}